import { connect } from 'react-redux';
import * as actions from '../../reducers/design-reducers';
import Loadable from 'react-loadable';
import Loading from '../../components/loading';

const App = Loadable({
  loader: () => import('../../layout/design'),
  loading: Loading
});

const mapStateToProps = ({ login }) => {
    return {
      isAuthenticated: login.isAuthenticated,
      inProgress: login.inProgress,
      message: login.message,
      openSnacbar: login.openSnacbar,
      choice: login.choice,
      toggle: login.toggle,
      mobData: login.mobData,
      otpData: login.otpData,
    }
  };

const AppContainer = connect(
    mapStateToProps,
    actions
)(App)

export default AppContainer;


// WEBPACK FOOTER //
// ./src/containers/layout/design.container.js